/* eslint-disable import/prefer-default-export */
export const COOKIES = ['ph_', 'ph_*'];
